module.exports = __webpack_public_path__ + "static/media/SDFSA_2-384w.ac9923db.jpg";